import { faCopy } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import { DataResult } from "@progress/kendo-data-query";
import _ from "lodash";
import { DATA_ITEM_KEY } from "../../../../Grid/GridConstants";
import { KENDO_BUTTON_CLASSES } from "../../../../Layout/Buttons/KendoButtons";
import { IconWithRightMargin } from "../../../../Layout/Icons/IconWithRightMargin";
import { UppercaseButton } from "../../../../Layout/Buttons/UppercaseButton";

interface Props {
  readonly dataResult: DataResult;
  readonly selectedIds: Array<number>;
  readonly addValidationItemsToData: (a: Array<any>) => void;
}

export default function CopyValidationItemsButton({
  dataResult,
  selectedIds,
  addValidationItemsToData,
}: Props) {
  const onCopyValidationButton = () => {
    const id = selectedIds[0];

    const sourceItem = dataResult.data.find((x) => _.get(x, DATA_ITEM_KEY) === id);
    const copiedItem = {
      ImportDate: new Date(),
      LastModifiedDate: new Date(),
      UpdateMode: 0,
      ContainerNetwork: sourceItem.ContainerNetwork,
      PlantGsdb: sourceItem.PlantGsdb,
      InboundDock: sourceItem.InboundDock,
      SupplierGsdb: sourceItem.SupplierGsdb,
      ContainerType: sourceItem.ContainerType,
    };
    addValidationItemsToData([copiedItem]);
  };

  return (
    <UppercaseButton
      className={KENDO_BUTTON_CLASSES}
      onClick={onCopyValidationButton}
      disabled={selectedIds.length !== 1}
    >
      <IconWithRightMargin icon={faCopy} />
      COPY VALIDATION ITEM
    </UppercaseButton>
  );
}
